/**
 * External dependencies
 */
import { get, omit, forOwn, omitBy, values } from 'lodash';

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.EDIT_LOCATION]: (state, action) => {
            const id = action.payload.id || '';
            const location = action.payload.location;
            const newEditLogs = appendToEditsLog(get(state, id), location);

            return {
                ...state,
                [id]: newEditLogs,
            };
        },
        [actions.RESET_LOCATION]: (state, action) => {
            const id = action.payload.id || '';
            return omit(state, id);
        },
    },
);